import AuthorPage from '../../../components/AuthorPage/AuthorPage';
import RentalsLayout from '../../../components/RentalsLayout/RentalsLayout';
import { buildPrimaryAuthorPage } from '../../../util/buildPrimaryAuthorPage';

// Build the page using the utility
const { getStaticProps, getStaticPaths, Page } = await buildPrimaryAuthorPage({
    site: 'RENTALS',
    LayoutComponent: RentalsLayout,
    ContentComponent: AuthorPage,
    menuPropName: 'submenu',
});

// Next.js expects named exports, so we use a wrapper
export { getStaticProps, getStaticPaths };

export default Page;
